import React from 'react';
import { Field } from 'redux-form';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from 'material-ui/MenuItem';

import SelectField from 'helpers/reduxFormMaterialUiNext/Select';
import Header from 'components/shared/Header';
import { localize } from 'react-localize-redux';

class RolesFields extends React.Component {
  render() {
    return (
      <div>
        <Header
          name={this.props.translate('landlordPortal.permissionFields.headerUpcase').props.children}
          style={{ margin: '0px -20px 10px -20px' }}
        />

        <div className="row">
          <div className="col-xs-12">
            <FormControl>
              <InputLabel htmlFor="role">
                {this.props.translate('landlordPortal.permissionFields.role').props.children}
              </InputLabel>
              <Field name="role" component={SelectField} onChange={this.props.onChange}>
                <MenuItem value="custom">
                  {this.props.translate('landlordPortal.permissionFields.custom').props.children}
                </MenuItem>
                {this.props.roles.map(role => (
                  <MenuItem key={`role_${role.value}`} value={role.value}>
                    {role.label}
                  </MenuItem>
                ))}
              </Field>
            </FormControl>
          </div>
        </div>
      </div>
    );
  }
}

export default localize()(RolesFields);
